import React from "react";
import completed from "../../../images/completed.png";
import CardIcon from "../../../images/instrument.svg"

export default function AssessmentCard({ isTickVisible,assessmentName }) {
 
  return (
    <div
      style={{
        width: "280px",
        padding: "10px",
        background: "#F5F5F5",
        borderRadius: "12px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ padding: "10px", textAlign: "left" }}>
        <img style={{ width:'31px'}} src={CardIcon} alt="dashboard icon" />
        <h4 style={{ color:'#2C3E50', paddingTop:'20px',fontSize:'24px',fontWeight:'600' }}>{assessmentName}</h4>
        <p style={{ color:'#2C3E508C',fontSize:'14px',fontWeight:'500'}}>Assessment</p>
      </div>
      {isTickVisible ? (
        <div
          style={{

            width: "25px",
            height: "25px",
            borderRadius: "50%",
          }}
        >
          <img src={completed} alt="Completed Image" />
        </div>
      ) : (
        <div
          style={{
            color: "white",
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            background: "#f6f6f6",
            border: "1px solid grey",
          }}
        ></div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/_components/common/AssessmentCard/index.jsx